module.exports = __webpack_public_path__ + "static/media/persimmon01-small.8dbf1b4a.jpeg";